"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var recoil_1 = require("recoil");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@/components");
var Styled = __importStar(require("./CreateApplicationForm.styled"));
var applicationForm_1 = require("@/types/dto/applicationForm");
var api = __importStar(require("@/api"));
var store_1 = require("@/store");
var Select_component_1 = require("@/components/common/Select/Select.component");
var ApplicationFormTemplate_component_1 = __importDefault(require("@/components/ApplicationForm/ApplicationFormTemplate/ApplicationFormTemplate.component"));
var hooks_1 = require("@/hooks");
var utils_1 = require("@/utils");
var Toast_component_1 = require("@/components/common/Toast/Toast.component");
var constants_1 = require("@/constants");
var DEFAULT_QUESTION = {
    content: '',
    description: '',
    maxContentLength: null,
    questionType: applicationForm_1.QuestionKind.multiLineText,
    required: false,
};
var current = new Date().toISOString();
var DEFAULT_QUESTIONS = new Array(4).fill(DEFAULT_QUESTION);
var CreateApplicationForm = function () {
    var _a = __read((0, react_2.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var methods = (0, react_hook_form_1.useForm)({
        defaultValues: {
            questions: DEFAULT_QUESTIONS,
        },
    });
    var register = methods.register, handleSubmit = methods.handleSubmit, setValue = methods.setValue, control = methods.control, formState = methods.formState;
    var _b = (0, react_hook_form_1.useFormState)({ control: control }), isDirty = _b.isDirty, isSubmitSuccessful = _b.isSubmitSuccessful;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var teams = (0, recoil_1.useRecoilValue)(store_1.$teams);
    var teamOptions = (0, react_2.useMemo)(function () {
        return teams.map(function (team) { return ({
            value: team.teamId.toString(),
            label: team.name,
        }); });
    }, [teams]);
    var handleAddToast = (0, hooks_1.useToast)().handleAddToast;
    var refreshSelectorFamilyByKey = (0, hooks_1.useRefreshSelectorFamilyByKey)();
    var handleSubmitForm = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (data.questions.length === 0) {
                    handleAddToast({
                        type: 'error',
                        message: '최소 한가지의 질문을 작성해야합니다.',
                    });
                    return [2 /*return*/];
                }
                set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                    key: store_1.ModalKey.alertModalDialog,
                    isOpen: true,
                    props: {
                        heading: '저장하시겠습니까?',
                        paragraph: '지원서 설문지 내역에서 확인하실 수 있습니다.',
                        confirmButtonLabel: '저장',
                        handleClickConfirmButton: function () {
                            (0, utils_1.request)({
                                requestFunc: function () {
                                    setIsLoading(true);
                                    return api.createApplicationForm(data);
                                },
                                errorHandler: handleAddToast,
                                onSuccess: function (response) {
                                    set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                                        key: store_1.ModalKey.alertModalDialog,
                                        isOpen: false,
                                    });
                                    var applicationFormId = response.data.applicationFormId;
                                    handleAddToast({
                                        type: Toast_component_1.ToastType.success,
                                        message: '성공적으로 지원서 설문지를 작성했습니다.',
                                    });
                                    refreshSelectorFamilyByKey('applicationForms');
                                    navigate((0, constants_1.getApplicationFormDetailPage)(applicationFormId));
                                },
                                onCompleted: function () {
                                    setIsLoading(false);
                                    set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                                        key: store_1.ModalKey.alertModalDialog,
                                        isOpen: false,
                                    });
                                },
                            });
                        },
                    },
                });
                return [2 /*return*/];
            });
        }); };
    });
    var position = (0, recoil_1.useRecoilValue)(store_1.$profile)[2];
    (0, react_2.useEffect)(function () {
        var _a;
        if (((_a = formState.errors.teamId) === null || _a === void 0 ? void 0 : _a.type) === 'required') {
            handleAddToast({
                type: Toast_component_1.ToastType.error,
                message: '플랫폼을 선택해주세요.',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState.errors.teamId]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, __assign({}, methods, { children: (0, jsx_runtime_1.jsxs)(Styled.ApplicationFormControlPage, { children: [(0, jsx_runtime_1.jsx)(components_1.ApplicationFormSection, { headline: "\uC9C0\uC6D0\uC11C \uC124\uBB38\uC9C0 \uC791\uC131" }, void 0), (0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit(handleSubmitForm) }, { children: [(0, jsx_runtime_1.jsx)("article", { children: (0, jsx_runtime_1.jsx)(ApplicationFormTemplate_component_1.default, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)(components_1.ApplicationFormAside, { createdAt: current, platform: (0, jsx_runtime_1.jsx)(Styled.TeamSelect, __assign({ placeholder: "\uD50C\uB7AB\uD3FC \uC120\uD0DD", size: Select_component_1.SelectSize.sm, options: teamOptions, onChangeOption: function (option) { return setValue('teamId', Number(option.value)); } }, register("teamId", { required: true })), void 0), createdBy: position, leftActionButton: { text: '취소', onClick: function () { return navigate(-1); }, isLoading: isLoading }, rightActionButton: { text: '저장', type: 'submit' } }, void 0)] }), void 0)] }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(components_1.Blocker, { isBlocking: isDirty && !isSubmitSuccessful }, void 0)] }, void 0));
};
exports.default = CreateApplicationForm;
